import L from "leaflet";
import type { DrawMode, LatLngTuple } from "../core/options";
import { drawColor, drawInvalidColor } from "./host";
import type { ToolHost } from "./host";
import { LineTool } from "./LineTool";

export class PolygonTool extends LineTool {
  override readonly mode: DrawMode = "polygon";

  constructor(host: ToolHost) {
    super(host, true);
  }

  protected override createPath(): L.Polyline<GeoJSON.LineString | GeoJSON.MultiLineString | GeoJSON.Polygon | GeoJSON.MultiPolygon> {
    return L.polygon([], {
      pane: this.host.pane,
      renderer: this.host.renderer,
      className: "fxmap-draw-path fxmap-draw-polygon",
      color: drawColor,
      weight: 3,
      opacity: 0.95,
      fillColor: drawColor,
      fillOpacity: 0.15,
      interactive: true,
      bubblingMouseEvents: false
    }).addTo(this.host.host.map);
  }

  override render(points: LatLngTuple[], valid: boolean): void {
    super.render(points, valid);
    this.path.setStyle({ fillOpacity: valid ? 0.15 : 0.05, fillColor: valid ? drawColor : drawInvalidColor });
  }
}
